import React from 'react'
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined'
import DashboardStatCard from './DashboardStatCard'
import { useDashboardStatsCard } from '../../store/dashboardStats'
import type { DashboardStatCardStationProps } from './types'

const MyPrepItemsCard: React.FC<DashboardStatCardStationProps> = ({ stationId }) => {
  const { value, loading, error } = useDashboardStatsCard(stationId, 'myPrepCount')

  return (
    <DashboardStatCard
      title="My prep items"
      value={value}
      loading={loading}
      error={error}
      icon={AssignmentOutlinedIcon}
    />
  )
}

export default MyPrepItemsCard
